import BeetAPI from '@boite-beet/api-client'

import '@/styles/app.scss'
import { createApp } from 'vue'
import { createGtag } from 'vue-gtag'
import { Vue3Mq } from 'vue3-mq'

import GlobalComponents from '@/components/global'
import langRouter from '@/extensions/langRouter'
import reveal from '@/extensions/reveal'
import i18n from '@/i18n'
import router from '@/router'
import store from '@/store'

import App from './App.vue'

/* --- EXTENSIONS --- */
const app = createApp(App)
  .use(i18n)
  .use(store)
  .use(router)
  .use(langRouter, 'fr')
  .use(reveal)
  .use(GlobalComponents)
  .use(BeetAPI, { store, apiUrl: import.meta.env.VITE_APP_API_URL })
  .use(Vue3Mq, {
    breakpoints: {
      xs: 0,
      sm: 566,
      md: 850,
      lg: 1360,
      xl: 1440,
    },
  })

/* --- GOOGLE ANALYTICS --- */
app.use(
  createGtag({
    tagId: import.meta.env.VITE_APP_GTAG_ID,
    initMode: 'manual',
    pageTracker: { router },
  }),
)

/* --- GOOGLE RECAPTCHA ---
import {VueReCaptcha} from "vue-recaptcha-v3";
app.use(VueReCaptcha, { siteKey: import.meta.env.VITE_APP_RECAPTCHA_KEY })
*/

/* --- MOUNT --- */
app.mount('#app')
